import { CommonModule } from '@angular/common'
import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import {
	getClient,
	getStatusVenues,
	getVenuesFromSelectedCity,
	VenueActions,
} from '@monorepo-channels/channels/domain'
import { SelectCardComponent, CelebrationsCardComponent } from '@monorepo-channels/feature-pm'
import { Store } from '@ngrx/store'
import {
	BehaviorSubject,
	combineLatest,
	debounceTime,
	distinctUntilChanged,
	map,
	Observable,
	startWith,
	Subject,
	takeUntil,
} from 'rxjs'
import { VenueCardUiComponent, LoadingPageComponent } from '@monorepo-channels/components/ui-pm'
import { City, CityService, UF_CODE_MAP } from '@monorepo-channels/shared/util-helpers'
import { MatButtonModule } from '@angular/material/button'
import { RouterLink } from '@angular/router'

@Component({
	standalone: true,
	selector: 'pm-basket-page',
	imports: [
		SelectCardComponent,
		CelebrationsCardComponent,
		MatIconModule,
		MatInputModule,
		ReactiveFormsModule,
		CommonModule,
		VenueCardUiComponent,
		LoadingPageComponent,
		MatButtonModule,
		RouterLink,
	],
	styleUrls: ['./basket.component.scss'],
	templateUrl: './basket.component.html',
})
export class BasketPageComponent implements OnInit, OnDestroy {
	private store = inject(Store)
	private destroy$ = new Subject<void>()
	private cityService = inject(CityService)

	public ufCodeMap = UF_CODE_MAP
	public selectedCity?: City

	public searchControl = new FormControl('', { nonNullable: true })
	public cities$ = this.cityService.cities$
	public filteredCities$!: Observable<City[]>
	private filterTerm = new BehaviorSubject<string>('')

	public statusVenues$ = this.store.select(getStatusVenues)
	public venues$ = this.store.select(getVenuesFromSelectedCity)
	public client = this.store.select(getClient)
	public hasFilteredCities$!: Observable<boolean>

	ngOnInit() {
		this.filteredCities$ = combineLatest([
			this.cities$,
			this.filterTerm.pipe(startWith(''), debounceTime(300), distinctUntilChanged()),
		]).pipe(map(([cities, searchText]) => this.cityService.filterCities(cities, searchText)))

		this.hasFilteredCities$ = this.filteredCities$.pipe(map(cities => !!cities && cities.length > 0))

		this.searchControl.valueChanges
			.pipe(takeUntil(this.destroy$))
			.subscribe(value => this.filterTerm.next(value || ''))
	}

	ngOnDestroy() {
		this.destroy$.next()
		this.destroy$.complete()
	}

	onSelectCity(city: City): void {
		this.selectedCity = city
		this.searchControl.setValue(city.nome, { emitEvent: false })
		this.filterTerm.next('')

		this.store.dispatch(
			VenueActions.selectCityAndLoadVenues({
				latitude: city.latitude,
				longitude: city.longitude,
				maxDistance: 50000,
			})
		)
	}

	clearFilter(): void {
		this.selectedCity = undefined
		this.searchControl.setValue('', { emitEvent: false })
		this.filterTerm.next('')
		this.store.dispatch(VenueActions.clearSelectedCity())
		this.store.dispatch(VenueActions.getVenues())
	}
}
